import { useId } from 'react';
import type { SpokePath } from './useSpokePositions';
import styles from './HubSpoke.module.css';

interface HubSpokeSvgProps {
  paths: SpokePath[];
  isVisible: boolean;
}

const RAIL_COLORS: Record<string, string> = {
  left: 'rgba(255, 150, 80, 0.12)',
  right: 'rgba(66, 210, 213, 0.12)',
  bottom: 'rgba(255, 255, 255, 0.08)',
};

const STREAK_COLORS: Record<string, string> = {
  left: 'rgba(255, 150, 80, 0.9)',
  right: 'rgba(66, 210, 213, 0.9)',
  bottom: 'rgba(255, 255, 255, 0.7)',
};

const STREAK = 0.12;

export function HubSpokeSvg({ paths, isVisible }: HubSpokeSvgProps) {
  const uid = useId();

  return (
    <svg
      className={`${styles.svgOverlay} ${isVisible ? styles.svgVisible : ''}`}
      aria-hidden="true"
    >
      <defs>
        <filter id={`${uid}-glow`}>
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {paths.map((p) => (
        <path
          key={`rail-${p.id}`}
          d={p.d}
          pathLength={1}
          fill="none"
          stroke={RAIL_COLORS[p.side]}
          strokeWidth={1.5}
          className={styles.rail}
        />
      ))}

      {paths.map((p, pi) => (
        <path
          key={`streak-${p.id}`}
          d={p.d}
          pathLength={1}
          fill="none"
          stroke={STREAK_COLORS[p.side]}
          strokeWidth={2}
          strokeLinecap="round"
          strokeDasharray={`${STREAK} ${1 - STREAK}`}
          filter={`url(#${uid}-glow)`}
          className={styles.streak}
          style={{ '--streak-stagger': `${pi * 0.4}s` } as React.CSSProperties}
        />
      ))}
    </svg>
  );
}
